import { compose, withProps } from 'recompose';
import { Link, withRouter } from 'react-router';
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import moment from 'moment-timezone';

import { linkShape } from '../shapes';
import Icon, { GLYPHS } from './Icon';
import WithApplePay from '../hoc/WithApplePay';
import { extendLocation, parseTimeSlug } from '../utils/helpers';
import { getShopByRoute, getIsKrwnZazzPlaceSteFoyShop } from '../shops/selectors';
import { getServiceName } from '../services/selectors';
import withKioskProp from '../hoc/WithKioskProp';
import WithReserveTimeHandler from '../hoc/WithReserveTimeHandler';
import WithTimezone from '../hoc/WithTimezone';
import analytics from '../applicationServices/analytics/BookingAnalytics';
import { getActiveDay, getActiveTime } from '../times/selectors';
import { getBarberByIdOrRoute } from '../barbers/selectors';

const ReserveLink = ({ to, shouldShowApplePay, reserveTime, service, date, time, timezone, from, barber, shop }) => {
  const proceedToCheckout = (isApplePay = false) => (...args) => {
    analytics.proceedToCheckout({
      ...(from === 'barber' ? { barber: barber && barber.toJS() } : { service }),
      date,
      time: moment.tz(time, timezone).format('h:mmA'),
      isApplePay,
      shouldShowApplePay,
      shop,
    });

    return reserveTime(...args, to);
  };

  return (
    <div className="layout layout--auto layout--center u-mt">
      <div className="layout__item">
        <Link
          onClick={proceedToCheckout()}
          to={to}
          className="c-btn c-btn--primary"
        >
          Review & Book
        </Link>
      </div>
      { shouldShowApplePay &&
        <div className="layout__item">
          <Link
            onClick={proceedToCheckout(true)}
            to={extendLocation(to, { query: { applePay: true } })}
            className="c-btn c-btn--default"
          >
            <Icon glyph={GLYPHS.APPLE} size="large" /> Review & Pay
          </Link>
        </div>
      }
    </div>
  );
};
ReserveLink.propTypes = {
  to: linkShape.isRequired,
  from: PropTypes.string.isRequired,
  shouldShowApplePay: PropTypes.bool.isRequired,
  reserveTime: PropTypes.func.isRequired,
  service: PropTypes.string.isRequired,
  barber: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
  shop: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
  date: PropTypes.string.isRequired,
  time: PropTypes.string.isRequired,
  timezone: PropTypes.string.isRequired,
};
export default compose(
  withKioskProp,
  WithApplePay,
  WithTimezone,
  withRouter,
  WithReserveTimeHandler,
  connect(
    (state, ownParams) => ({
      isKrwnZazzPlaceSteFoyShop: getIsKrwnZazzPlaceSteFoyShop(state, ownParams.params.shopRoute),
      service: getServiceName(state, ownParams.params.serviceId),
      date: getActiveDay(state),
      time: parseTimeSlug(getActiveTime(state), ownParams.timezone),
      barber: getBarberByIdOrRoute(state, ownParams.params.barberRoute),
      shop: getShopByRoute(state, ownParams.params.shopRoute),
    })
  ),
  withProps(props => ({
    shouldShowApplePay: !props.kiosk && props.hasApplePay && !props.isKrwnZazzPlaceSteFoyShop,
  })),
)(ReserveLink);



// WEBPACK FOOTER //
// ./src/app/components/ReserveLink.jsx